import type {EagColumn} from '../../../../../types/EagColumn';
import {matchesColumnSearch} from '../../../../../utils/matchesColumnSearch';
import {normalizeSearchText} from '../../../../../utils/normalizeSearchText';

/**
 * Filters flat columns by headerName OR group label, case- and
 * diacritics-insensitively, so typing a group name lists that group's columns.
 */
export const filterFlatColumns = (columns: EagColumn[], searchTerm: string): EagColumn[] => {
  const normalized = normalizeSearchText(searchTerm);
  if (!normalized) {
    return columns;
  }
  return columns.filter((column) =>
    matchesColumnSearch(column.headerName, column.group, normalized)
  );
};
